import React, { PureComponent } from 'react';
import axios from 'axios';
import { Modal, notification } from 'antd';
import { FormattedMessage } from 'react-intl';
import { hp } from "../../utils";


class Verification extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            token: window.location.pathname.split('/')[3],
            exists: false, loading: false, submitting: false,
            authenticated: props._auth.authenticated,
            account: {}, person: {},
        };
    }

    componentDidMount() {
        const self = this;
        const { token } = this.state;
        this.setState({ loading: true });
        axios({
            method: 'GET',
            url: `${hp.getApiBaseUrl()}/verifications/${token}`,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        }).then((response) => {
            const res = response.data;
            let user = this.props._auth.user;
            const { _auth: { authenticated }, _utils } = this.props;
            if (res.statusCode === 200) {
                if (authenticated) {
                    user['status'] = 'ACTIVE';
                    hp.setCookie('user', JSON.stringify(user), 7);
                    window.location.assign(process.env.REACT_APP_SUCCESS_REDIRECT);
                } else {
                    window.location.assign(`/${_utils.lang || 'en'}/signin`);
                }
            } else {
                notification.error({ message: 'Unable to verify account' });
            }
        }).catch((err) => {
            Modal.info({
                title: <FormattedMessage id="Invitation.Invalid.Title" defaultMessage="Invalid invitation link" />,
                content: <FormattedMessage id="Invitation.Invalid.Description.Database" defaultMessage="This invitation was not found in our database" />,
                okText: <FormattedMessage id="Button.SignIn" defaultMessage="Sign in" />,
                onOk() {
                    window.location.assign(`/${self.props._utils.lang || 'en'}/signin`);
                }
            });
        });
    }


    render() {
        return (
            <React.Fragment>

            </React.Fragment>
        );
    }
}

export default Verification;